import { format } from "date-fns"
import { ko } from "date-fns/locale"
import { Calendar as CalendarIcon, ChevronLeft, ChevronRight } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"

interface DatePickerProps {
  date: Date
  setDate: (date: Date) => void
  highlightedDates?: Date[]
  onPrevDay?: () => void
  onNextDay?: () => void
}

export function DatePicker({ date, setDate, highlightedDates = [], onPrevDay, onNextDay }: DatePickerProps) {
  return (
    <div className="flex items-center space-x-2 min-w-0">
      <Button 
        variant="outline" 
        size="icon"
        onClick={onPrevDay}
        className="h-8 w-8 sm:h-9 sm:w-9"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className={cn(
              "w-[170px] sm:w-[240px] justify-center text-left font-normal truncate",
              !date && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date ? format(date, "PPP", { locale: ko }) : <span>날짜 선택</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="center">
          <Calendar
            mode="single"
            selected={date}
            onSelect={(newDate) => newDate && setDate(newDate)}
            initialFocus
            highlightedDates={highlightedDates}
          />
        </PopoverContent>
      </Popover>
      
      <Button 
        variant="outline" 
        size="icon"
        onClick={onNextDay}
        className="h-8 w-8 sm:h-9 sm:w-9"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  )
} 